import state from "./OverviewState";
import {getData} from "@/api/baseApi";

export default {
    namespaced: true,
    state: state,
    mutations: {
        setStatistics(state, data) {
            state.statistics = data;
        }
    },
    actions: {
        getStatistics({commit}) {
            getData("system", "overview", "statistics").then(res => {
                if (res.code === 200) {
                    commit("setStatistics", res.data);
                }
            }).catch(() => {
            });
        }
    },
    modules: {}
}
